export default [
	// 超卖订单
	{
		path: 'oversold_list',
		name: 'm_overseal_order',
		props: route => route.params,
		component: () => import('@/pages/sales/oversold_list')
	},
	// 销售接驳列表
	{
		path: 'sales_handover',
		name: 'm_sales_handover',
		props: route => route.params,
		component: () => import('@/pages/sales/handover_list')
	},
	// 销售商品列表
	{
		path: 'product_list',
		name: 'm_product_list',
		props: route => route.params,
		component: () => import('@/pages/sales/product_list')
	},
	// 下架异常商品列表
	{
		path: 'abnormal_list',
		name: 'm_abnormal_list',
		props: route => route.params,
		component: () => import('@/pages/sales/abnormal_list')
	},
	// 推送列表
	{
		path: 'push_list',
		name: 'm_push_list',
		props: route => route.params,
		component: () => import('@/pages/sales/push_list')
	},
	// 出价列表
	{
		path: 'bid_list',
		name: 'm_bid_list',
		props: route => route.params,
		component: () => import('@/pages/sales/bid_list')
	},
	// 询价列表
	{
		path: 'inquiry_list',
		name: 'm_inquiry_list',
		props: route => route.params,
		component: () => import('@/pages/sales/inquiry_list')
	},
	// 借出列表
	{
		path: 'loan_list',
		name: 'm_loan_list',
		props: route => route.params,
		component: () => import('@/pages/sales/lend_list')
	},
];
